import React, { useState } from 'react'
import { deleteFeedApi } from '../../../../services/feeds';
import { toastMessage } from '../../../../utils/toastMessage';
import DeleteModal from '../../../../components/modals/DeleteModal';
import { useNavigate } from 'react-router';

const DeleteFeed = ({ show, close, id, scroll = false, navigate = false, listing = () => { }, feedName = 'this group', setPage, setHasMore }) => {
    const [loading, setLoading] = useState(false);
    const navigator = useNavigate()
    //-----------exit-group--------------
    const deleteFeed = async () => {
        try {
            setLoading(true);
            const { data } = await deleteFeedApi({ _id: id });
            const { success, message } = data;
            if (success) {
                if (scroll) {
                    setPage(1)
                    setHasMore(true)
                    // setTimeout(() => {
                    listing(1, true);
                    // }, 1000);
                } else if (navigate) {
                    navigator(-1)
                } else {
                    listing()
                }
                close();
                toastMessage(message, "success", "deleteFeed");
            }
        } catch (e) {
            console.log("Error=-", e.message);
        } finally {
            setLoading(false);
        }
    };
    return (
        <DeleteModal
            show={show}
            handleClose={close}
            deleteAccountHandler={deleteFeed}
            loading={loading}
            text={<span>Are you sure you want to delete from <b>{feedName}</b>?</span>}
        />
    )
}

export default DeleteFeed